import Audit from '@/store/models/Audit'
import { startAudit, loadAppAudit, deleteAudit } from '@/api/audit'
import { flatMap } from 'lodash'

let auditModel = new Audit()

export default {
  namespaced: true,

  state: {
    audit: auditModel
  },

  mutations: {
    ...auditModel.mutations()
  },

  actions: {
    startAudit: ({ state }) => new Promise((resolve, reject) => {
      startAudit(state.audit, ({data}) => {
        resolve(data.id)
      }, reject)
    }),
    loadAppAudit: ({ commit }, payload) => new Promise((resolve, reject) => loadAppAudit(payload, ({data}) => {
      commit('setAudit', data)
      resolve()
    }, reject)),
    deleteAudit: ({ state }) => new Promise((resolve, reject) => deleteAudit(state.audit.id, ({data}) => {
      resolve()
    }, reject)),
  },

  getters: {
    audit: state => state.audit,
    findings: state => state.audit.findings,
    checkpoints: state => {
      let sections = state.audit.standard.sections
      return flatMap(sections, section => section.checkpoints)
    }
  }
}